// NPM Imports
import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// CSS Imports
import style from "./revvBtn.module.scss";

const Button = props => {
  const { children, className, icon, isLoading, type, ...otherProps } = props;
  let buttonType = "";
  switch (type) {
    case "one":
      buttonType = `${style.typeOne}`;
      break;
    case "two":
      buttonType = `${style.typeTwo}`;
      break;
    case "three":
      buttonType = `${style.typeThree}`;
      break;
    case "four":
      buttonType = `${style.typeFour}`;
      break;
    case "five":
      buttonType = `${style.typeFive}`;
      break;
    case "six":
      buttonType = `${style.typeSix}`;
      break;
    default:
      buttonType = "";
      break;
  }

  return (
    <button
      className={`${style.container} ${buttonType} ${
        isLoading ? style.isLoading : ""
      } ${className}`}
      tabIndex="0"
      type="button"
      data-test="button"
      {...otherProps}>
      {icon.length > 0 && (
        <i>
          <FontAwesomeIcon icon={[icon[0], icon[1]]} />
        </i>
      )}
      {isLoading && (
        <span className={`${style.loader}`}>
          <i className={`${style.loaderIcon}`}>
            <FontAwesomeIcon icon={["far", "spinner"]} className="fa-spin" />
          </i>
        </span>
      )}
      <span>{children}</span>
    </button>
  );
};

Button.defaultProps = {
  className: "",
  icon: [],
  isLoading: false,
  type: "",
};

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  icon: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.string,
  ]),
  isLoading: PropTypes.bool,
  type: PropTypes.string,
};

export default Button;
